module.exports = __webpack_public_path__ + "media/The Last Broadcast Trailer.596eadf2.mp4";